const extractRefId = (value) => {
  if (!value) return null;
  return String(typeof value === "object" ? value._id ?? value.user : value);
};

/**
 * @returns {'attended' | 'justified' | 'absent'}
 */
export const getGeneralMeetingAttendanceStatus = (event, userId) => {
  if (!userId || !event) return "absent";

  const normalizedUserId = String(userId);

  if (
    Array.isArray(event.participants) &&
    event.participants.some(
      (participant) => extractRefId(participant) === normalizedUserId,
    )
  ) {
    return "attended";
  }

  if (Array.isArray(event.justifiedAbsences)) {
    const justified = event.justifiedAbsences.find(
      (entry) => extractRefId(entry?.user) === normalizedUserId,
    );
    if (justified?.justification?.trim()) return "justified";
  }

  return "absent";
};

export const isGeneralMeetingPresent = (event, userId) =>
  getGeneralMeetingAttendanceStatus(event, userId) !== "absent";

export const getGeneralMeetingJustification = (event, userId) => {
  if (!userId || !Array.isArray(event?.justifiedAbsences)) return null;

  const normalizedUserId = String(userId);
  const entry = event.justifiedAbsences.find(
    (item) => extractRefId(item?.user) === normalizedUserId,
  );

  return entry?.justification?.trim() || null;
};

export const parseJustifiedAbsencesFromEvent = (event) => {
  if (!Array.isArray(event?.justifiedAbsences)) return [];

  return event.justifiedAbsences
    .map((entry) => ({
      userId: extractRefId(entry?.user),
      justification: entry?.justification?.trim() || "",
    }))
    .filter((entry) => entry.userId && entry.justification);
};
